import React, { useRef, useState } from "react";
import { ButtonToolbar } from "rsuite";
import { makeStyles, useMediaQuery } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";

import { GridModalButtons } from "./ModalButtons";
import { checkIfSubformOpened3 } from "./gridUtils";
import CustomizedAlert from "../../../ReusableComponents/Alert/CustomizedAlert";

const GridModalFooter = (props) => {
  const useStylesGridFooter = makeStyles(() => ({
    container: {
      background: props?.modalType !== "modal" && "inherit",
      height: "45px",
      minHeight: "45px",
      display: "flex",
      bottom: "0",
      width: "100%",
      left: "0",
      borderTop: (props?.modalType !== "modal" || props?.modalType !== "Through Popup") && "1px solid #C4C4C4",
      border:
        props?.modalType !== "belowSection" &&
        props.modalType !== "aboveSection" &&
        props?.gridJSON?.style?.additionmethods !== "Section above Listview" &&
        props?.gridJSON?.style?.additionmethods !== "Section below Listview" &&
        "1px solid #c4c4c4",
      padding: "0 16px",
      alignItems: "center"
    },
    buttonGroup: { gap: "16px !important" },
    batchIconsContainer: { height: "16px", display: "flex", alignItems: "center", gap: "24px" },
    batchIconSpan: { width: "16px", height: "100%", display: "block" },
    batchIcon: { width: "100%", height: "100%" },
    disableModalBatchIcon: {
      pointerEvents: "none",

      "& svg path": { fill: "#c4c4c4" }
    }
  }));

  const { gridJSON = {}, formState2, isViewer, extraProps = {} } = props;
  const { popupStyle = {} } = gridJSON;

  const matches = useMediaQuery("(max-width: 550px)");
  const classes = useStylesGridFooter({ matches });
  const [alertData, setAlertData] = useState({ open: false, showConfirm: "showNotification" });
  const { handleCol, handleClose } = extraProps;
  const {
    loading,
    showOverlayBatchButtonPartial,
    nextClick,
    previousClick,
    saveAndContinue,
    saveAndClose,
    saveChanges,
    selectedRowIndex,
    dataOfAdvFrom,
    duplicateRow
  } = extraProps;

  const themeData = formState2?.theme;
  const controlThemeData = themeData?.["ButtonStyle"] || {};
  const isAdvanceListview = gridJSON.elem_type?.toLowerCase() === "advancelistview";
  const idKey = gridJSON.elem_type === "listview" ? "listview" : "advListview";
  const buttonsDisableCheck =
    loading || (isAdvanceListview && dataOfAdvFrom?.size > 0) || gridJSON.style?.Enable !== "true";

  const advButtonThemeStyle = {
    primaryColor: `${controlThemeData["PrimaryButtonFontColor"] || "#fff"}`,
    primaryBackgroundColor: `${controlThemeData["PrimaryButtonBackgroundColor"] || "var(--button_color)"}`,
    primaryBorderColor: `${controlThemeData["PrimaryButtonBorderColor"] || "var(--button_color)"}`,
    secondaryColor: `${controlThemeData["SecondaryButtonFontColor"] || "var(--button_color)"}`,
    secondaryBorderColor: `${controlThemeData["SecondaryButtonBorderColor"] || "var(--button_color)"}`
  };

  const showOverlayBatchButton =
    showOverlayBatchButtonPartial && gridJSON.style?.Enable === "true" && 
    (gridJSON.popupStyle?.["ShowOverlayBatchsButtons"] === "true" ||
      !gridJSON.popupStyle?.["ShowOverlayBatchsButtons"]);

  const allowDuplicatingRow =
    gridJSON.elem_type === "listview" &&
    gridJSON.style?.Enable === "true" &&
    !(gridJSON.popupStyle?.AllowDuplicatingRow === false || gridJSON.popupStyle?.AllowDuplicatingRow === "false");
  
  const showLegacyId = window?.psh_configs?.show_legacy_ids === "Y"

  const showSaveChanges = gridJSON?.popupStyle?.["ShowSaveChanges"] !== "false";

  const processingRef = useRef(false);

  const handleButtonClick = (cb) => {
    if (processingRef?.current) return;

    let shouldAddRecord = true;
    if (isAdvanceListview) {
      shouldAddRecord = checkIfSubformOpened3(setAlertData, gridJSON);
    }
    if (shouldAddRecord && cb) {
      processingRef.current = true;
      cb();
      // Reset guard after delay — parent's loading state handles longer operations
      setTimeout(() => { processingRef.current = false; }, 1500);
    }
  };

  return (
    <div
      className={["rsuite_component_parent", classes.container].join(" ")}
      style={{
        position: isViewer ? "relative" : "absolute",
        backgroundColor: gridJSON.popupStyle?.["AdvListviewFooterBackgroundColor"] || "#fff",
        justifyContent: showOverlayBatchButton ? "space-between" : "end",
        pointerEvents: loading && !isViewer ? "none" : "unset",
        ...(matches ? { height: "auto", minHeight: "unset", padding: "12px" } : {})
      }}
    >
      {showOverlayBatchButton ? (
        <ButtonToolbar className={classes.buttonGroup}>
          {isViewer && matches && gridJSON.style?.Enable === "true" ? (
            <div className={classes.batchIconsContainer}>
              {/* icon will appear on mobile (@media only screen and (max-width: 550px)) */}
              <span
                className={[
                  classes.batchIconSpan,
                  selectedRowIndex === 0 || buttonsDisableCheck ? classes.disableModalBatchIcon : ""
                ].join(" ")}
                id={showLegacyId ? `${gridJSON.id}_${idKey}previousRowIcon` : `${gridJSON?.style?.CustomId || gridJSON?.dataclass || gridJSON?.id}_${idKey}previousRowIcon`}
                onClick={() => handleButtonClick(previousClick)}
              >
                <ChevronLeftIcon className={classes.batchIcon} />
              </span>

              <span
                className={[
                  classes.batchIconSpan,
                  selectedRowIndex === gridJSON.rowData?.length - 1 || buttonsDisableCheck
                    ? classes.disableModalBatchIcon
                    : ""
                ].join(" ")}
                id={showLegacyId ? `${gridJSON.id}_${idKey}_nextRowIcon` : `${gridJSON?.style?.CustomId || gridJSON?.dataclass || gridJSON?.id}_${idKey}_nextRowIcon`}
                onClick={() => handleButtonClick(nextClick)}
              >
                <ChevronRightIcon className={classes.batchIcon} />
              </span>
            </div>
          ) : null}

          {!matches && gridJSON.style?.Enable === "true" && (
            <>
              <GridModalButtons
                type="ghost"
                controlJson={gridJSON}
                advButtonThemeStyle={advButtonThemeStyle}
                label={popupStyle.PreviousButtonLabel || "Previous"}
                id={showLegacyId ? `${gridJSON.id}_${idKey}_previousRowBtn` : `${gridJSON?.style?.CustomId || gridJSON?.dataclass || gridJSON?.id}_${idKey}_previousRowBtn`}
                isViewer={isViewer}
                onClick={(event) => {
                  if (isViewer) {
                    handleButtonClick(previousClick);
                    event.target.blur();
                  }
                }}
                disabled={
                  gridJSON?.style?.DisablePreviousRow === true || gridJSON?.style?.DisablePreviousRow === false
                    ? gridJSON?.style?.DisablePreviousRow
                    : isViewer && (selectedRowIndex === 0 || buttonsDisableCheck)
                }
              />

              <GridModalButtons
                type="ghost"
                controlJson={gridJSON}
                advButtonThemeStyle={advButtonThemeStyle}
                label={popupStyle.NextButtonLabel || "Next"}
                id={showLegacyId ? `${gridJSON.id}_${idKey}_nextRowBtn` : `${gridJSON?.style?.CustomId || gridJSON?.dataclass || gridJSON?.id}_${idKey}_nextRowBtn`}
                isViewer={isViewer}
                onClick={(event) => {
                  if (isViewer) {
                    handleButtonClick(nextClick);
                    event.target.blur();
                  }
                }}
                disabled={
                  gridJSON?.style?.DisableNextRow === true || gridJSON?.style?.DisableNextRow === false
                    ? gridJSON?.style?.DisableNextRow
                    : isViewer && (selectedRowIndex === gridJSON.rowData?.length - 1 || buttonsDisableCheck)
                }
              />
            </>
          )}
        </ButtonToolbar>
      ) : null}

      <ButtonToolbar className={classes.buttonGroup}>
        {props.modalType !== "modal" && props.modalType !== "Through Popup" && (
          <GridModalButtons
            type="ghost"
            controlJson={gridJSON}
            isTertiary={true}
            advButtonThemeStyle={advButtonThemeStyle}
            label={popupStyle.CloseLabel || "Close"}
            id={`${gridJSON?.style?.CustomId || gridJSON?.dataclass || gridJSON?.id}_${idKey}_closeBtn`}
            isViewer={isViewer}
            onClick={isViewer ? () => handleButtonClick(handleClose) : null}
            // disabled={
            //   gridJSON?.style?.DisableClose === true || gridJSON?.style?.DisableClose === false
            //     ? gridJSON?.style?.DisableClose
            //     : isViewer && buttonsDisableCheck
            // }
          />
        )}

        {selectedRowIndex === -1 || !isViewer ? (
          <>
            <GridModalButtons
              type="ghost"
              controlJson={gridJSON}
              advButtonThemeStyle={advButtonThemeStyle}
              label={popupStyle.SaveAndContinueLabel || "Save & Continue"}
              id={showLegacyId ? `${gridJSON.id}_${idKey}_saveContinueBtn` : `${gridJSON?.style?.CustomId || gridJSON?.dataclass || gridJSON?.id}_${idKey}_saveContinueBtn`}
              isViewer={isViewer}
              onClick={() => isViewer && handleButtonClick(saveAndContinue)}
              disabled={
                gridJSON?.style?.DisableSaveAndContinue === true || gridJSON?.style?.DisableSaveAndContinue === false
                  ? gridJSON?.style?.DisableSaveAndContinue
                  : isViewer && buttonsDisableCheck
              }
            />
            <GridModalButtons
              controlJson={gridJSON}
              advButtonThemeStyle={advButtonThemeStyle}
              label={popupStyle.SaveAndCloseLabel || "Save & Close"}
              id={showLegacyId ? `${gridJSON.id}_${idKey}_saveCloseBtn` : `${gridJSON?.style?.CustomId || gridJSON?.dataclass || gridJSON?.id}_${idKey}_saveCloseBtn`}
              isViewer={isViewer}
              onClick={() => isViewer && handleButtonClick(saveAndClose)}
              disabled={
                gridJSON?.style?.DisableSaveNClose === true || gridJSON?.style?.DisableSaveNClose === false
                  ? gridJSON?.style?.DisableSaveNClose
                  : isViewer && buttonsDisableCheck
              }
            />
          </>
        ) : null}

        {selectedRowIndex >= 0 || !isViewer ? (
          <>
            {showSaveChanges ? (
              <GridModalButtons
                controlJson={gridJSON}
                advButtonThemeStyle={advButtonThemeStyle}
                label={popupStyle.SaveChangesLabel || "Save Changes"}
                id={showLegacyId ? `${gridJSON.id}_${idKey}_saveChangesBtn` : `${gridJSON?.style?.CustomId || gridJSON?.dataclass || gridJSON?.id}_${idKey}_saveChangesBtn`}
                isViewer={isViewer}
                onClick={() => isViewer && handleButtonClick(saveChanges)}
                disabled={
                  gridJSON?.style?.DisableSaveChanges === true || gridJSON?.style?.DisableSaveChanges === false
                    ? gridJSON?.style?.DisableSaveChanges
                    : isViewer && buttonsDisableCheck
                }
              />
            ) : null}

            {allowDuplicatingRow ? (
              <GridModalButtons
                type="ghost"
                controlJson={gridJSON}
                advButtonThemeStyle={advButtonThemeStyle}
                label={popupStyle.DuplicateRowLabel || "Duplicate Row"}
                id={showLegacyId ? `${gridJSON.id}_${idKey}_duplicateRowBtn` : `${gridJSON?.style?.CustomId || gridJSON?.dataclass || gridJSON?.id}_${idKey}_duplicateRowBtn`}
                isViewer={isViewer}
                onClick={() => handleButtonClick(duplicateRow)}
                disabled={loading || gridJSON?.style?.DisableDuplicateRow}
              />
            ) : null}
          </>
        ) : null}
      </ButtonToolbar>

      {alertData.open === true && <CustomizedAlert alertData={alertData} />}
    </div>
  );
};

export default GridModalFooter;
